"use client";
import { jsxs as s, jsx as l } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    focusable: "false",
    height: "100%",
    width: "100%",
    children: [
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l(
        "path",
        {
          id: "a",
          d: "m10.461 1.24 7.25 3.766a1 1 0 0 1 .539.887v8.214a1 1 0 0 1-.539.887l-7.25 3.767a1 1 0 0 1-.922 0l-7.25-3.767a1 1 0 0 1-.539-.887V5.893a1 1 0 0 1 .539-.887l7.25-3.767a1 1 0 0 1 .922 0ZM10 5.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z"
        }
      ) }),
      /* @__PURE__ */ l("use", { xlinkHref: "#a" })
    ]
  }
);
export {
  t as IconAsset
};
